import { render, staticRenderFns } from "./FlaggedCallsTable.vue?vue&type=template&id=3717f13a&scoped=true"
import script from "./FlaggedCallsTable.vue?vue&type=script&lang=js"
export * from "./FlaggedCallsTable.vue?vue&type=script&lang=js"
import style0 from "./FlaggedCallsTable.vue?vue&type=style&index=0&id=3717f13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3717f13a",
  null
  
)

export default component.exports